/** The round +N chip beside a list of names. */
export const MORE_CHIP_BASE_CLASS =
  'inline-flex items-center justify-center whitespace-nowrap rounded-full bg-secondary leading-none font-medium text-secondary-foreground tabular-nums';

/**
 * Dense rows (table cells, rail cards) get the smaller chip so it doesn't
 * outweigh the name; detail panels keep the larger one.
 */
export const MORE_CHIP_SIZE_CLASS = {
  stack: 'h-6 min-w-6 px-1 text-xs',
  compact: 'h-5 min-w-5 px-1 text-[10px]',
} as const;
